import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { query2obj } from './util';
/**
 * 自动匹配指令绑定的模块数据
 * @param {Object} binding 指令数据
 */

function fixAutoParams(binding) {
  if (!binding.value) return;

  if (typeof binding.value === 'string') {
    // eslint-disable-next-line
    binding.value = query2obj(binding.value);
  } // eslint-disable-next-line


  if (binding.modifiers && binding.modifiers.module && binding.value['模块']) {
    // 自动寻找上报数据子节点的模块数据
    // eslint-disable-next-line
    binding.value = binding.value['模块'];
  }
}
/**
 * 创建指令
 * @param {Vue.VueConstructor} Vue
 * @param {{ pv: VftReport.ReporterInstance, event: VftReport.ReporterInstance }} reporter
 * @param {IntersectionObserver} observer
 * @param {Array} middlewares
 * @return {Vue.DirectiveOptions}
 */


export function createDirective(Vue, middlewares) {
  function directiveHandler() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (Array.isArray(middlewares)) {
      var binding = args[1];
      fixAutoParams(binding);
      middlewares.forEach(function (middleware) {
        // eslint-disable-next-line
        middleware.useDirective.apply(middleware, args);
      });
    }
  }

  Vue.directive('report', {
    /**
     * @type {VftReport.DirectiveFunction}
     */
    bind: function bind(el, binding, vnode) {
      directiveHandler(el, binding, vnode, {
        event: 'bind'
      });
    },

    /**
     * @type {VftReport.DirectiveFunction}
     */
    update: function update(el, binding, vnode) {
      directiveHandler(el, binding, vnode, {
        event: 'update'
      });
    },

    /**
     * @type {VftReport.DirectiveFunction}
     */
    unbind: function unbind(el, binding, vnode) {
      directiveHandler(el, binding, vnode, {
        event: 'unbind'
      });
    }
  });
}